import { Link } from 'react-router-dom';
import { UncontrolledCollapse, NavbarBrand, Navbar, Container, Row, Col, Badge } from 'reactstrap';

const AdminNavbar = () => {
  const isBeta = window.location.hostname.includes('beta-app.arb.systems');

  return (
    <>
      <Navbar className="navbar-top navbar-horizontal navbar-dark" expand="md">
        <Container className="px-4 d-flex align-items-center">
          <NavbarBrand to="/" tag={Link} className="d-flex align-items-center">
            <img alt="..." src={require('../../assets/img/logo_white.png').default} />
            {isBeta && (
              <Badge color="primary" className="ml-2" style={{ fontSize: '0.75rem' }}>
                Beta
              </Badge>
            )}
          </NavbarBrand>

          <UncontrolledCollapse navbar toggler="#navbar-collapse-main">
            <div className="navbar-collapse-header d-md-none">
              <Row>
                <Col className="collapse-brand" xs="6">
                  <Link to="/">
                    <img alt="..." src={require('../../assets/img/logo_white.png').default} />
                  </Link>
                </Col>
                <Col className="collapse-close" xs="6">
                  <button className="navbar-toggler" id="navbar-collapse-main">
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
          </UncontrolledCollapse>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
